import React from 'react';
import { observer, inject } from "mobx-react";
import { Input, InputFile, SingleSwitch, Card, Messages  } from '@sogei/react-web-components-catalog'
import i18next from 'i18next';
//import { Card } from '../commons/cardApp';
import { Formik } from 'formik';
import * as Yup from 'yup'
import { AppButton } from '../commons/button';
import { scrollToTop } from '../commons/uiUtils';


@inject("rootStore")
@observer
class Qualifiche extends React.Component {

    constructor(props) {
        super(props);
        this.uiStore = props.rootStore.uiStore;
        this.routingStore = props.rootStore.routingStore;
        this.qualificheStore = props.rootStore.qualificheStore;
        this.set = this.set.bind(this);
    }  
    

    componentDidMount() {
      // dall'applicazione Unimod è possibile selezionare una qualifica diversa.
      if(this.props.forceReloadUnimod) {
        this.qualificheStore.fetchQualificheUnimod();
      }
    }

    set(qualifica) {
      this.qualificheStore.setQualifica(qualifica, () => {
        scrollToTop();
        this.uiStore.addSuccessMessage({text: i18next.t("MESSAGE_CONVENZIONE_SELEZIONATA")});
      });
    }


    componentWillUnmount() { }

    render() {    
        const qualifiche = this.qualificheStore.qualifiche;
        // quando non sono state ancora caricate le qualifiche, la pagina si presenta bianca
        if (qualifiche === undefined) {
          return <></>
        }

        return (
          <div className="container-fluid py-3 py-md-4">
            {qualifiche.length > 0 &&
              <div className="row">              
                <div className="col">
                  <h3>{i18next.t("CAMBIA_CONVENZIONE")}</h3>
                  <p>{i18next.t(this.qualificheStore.tipoPratica ==='MP'?"CAMBIA_CONVENZIONE_DESC_MP":"CAMBIA_CONVENZIONE_DESC")}
                  {this.qualificheStore.tipoPratica === 'MP'? <><br></br>{i18next.t("CAMBIA_CONVENZIONE_DESC_MP_1")}</>:undefined}
                  </p>
                    
                <div className='row'>
                  
                  {qualifiche.map((item,index)=> {
                      return <div className='col-12 col-md-4 col-xl-4   pl-5' key={'qualifica_'+index}>
                          <Card
                              title={item.denominazioneUtenza}
                              body={
                                  this.qualificheStore.tipoPratica !== 'CI' ? 
                              <>
                                  <span className="label">{i18next.t("TIPO_CONVENNZIONE")}:</span>
                                  <span className="text-nowrap">{
                                  item.ente
                                  ?
                                  item.ente.codfiscEnte 
                                  :
                                  item.collaborazioni && item.collaborazioni.length > 0 ? item.collaborazioni[0].identificativoReferente : undefined
                                  }</span>
                              </>
                              :
                              <>
                                  <span className="label">{i18next.t("TIPO_CONVENNZIONE")}:</span>
                                  <span className="text-nowrap">{item.ente.codfiscEnte}</span>
                              </>


                              
                            }
                              footer={
                                  <AppButton
                                  titleKey={i18next.t("BUTTON_SELEZIONA")}
                                  onClick={() => {this.set(item)}}
                                  />
                              }
                              iconBackground="fas fa-user-tag fa-card"
                              footerAlign="center"
                              cardType="primary"
                          /> 
                      </div>
                  })}
                  </div>
                </div>
              </div>
            }
            {(qualifiche.length == 0 && !this.qualificheStore.utenzaDiLavoroErrataFlag) && 
                  <div className='col'>
                    <Messages successMessages={[]} infoMessages={[]} warningMessages={[]} dangerMessages={[{text: i18next.t("MESSAGE_NO_QUALIFICHE")}]}></Messages> 
                  </div>
            }
            {(qualifiche.length == 0 && this.qualificheStore.utenzaDiLavoroErrataFlag) && 
                  <div className='col'>
                    <Messages successMessages={[]} infoMessages={[]} warningMessages={[]} dangerMessages={[{text: i18next.t("MESSAGE_CF_UL_ERRATA")}]}></Messages> 
                  </div>
            }
          </div>
        ); 
      }
}


export default Qualifiche

export { Qualifiche }

